<table
  mat-table
  [dataSource]="dataSource"
  *transloco="let t"
  cdkDropList
  [cdkDropListDisabled]="!reorderRows"
  [cdkDropListSortPredicate]="sortPredicate"
  (cdkDropListDropped)="onRowDropped($event)"
>
  @for (column of columns; track column.name) {
    <ng-container [matColumnDef]="column.name" [sticky]="column?.sticky">
      <!-- Cabeçalho da coluna -->
      <mat-header-cell
        *matHeaderCellDef
        [hidden]="column.hidden || (column.name === 'id' && column.hidden === undefined)"
        [style.minWidth.px]="column.minWidth"
        [style.maxWidth.px]="column.name === 'actions' ? 56 : column.maxWidth"
        [ngClass]="[column | columnAlignment, column?.hiddenSize || '']"
        class="px-1 dark:print:bg-white dark:print:text-black print:dark:border-b"
      >
        <!-- Botão Expandir/Recolher na primeira coluna -->
        @if (showMasterExpandButton && column.name === columns[0]?.name) {
          <button
            mat-icon-button
            class="print:hidden"
            (click)="toggleExpandCollapse()"
            [matTooltip]="(isTreeExpanded ? 'collapse-all' : 'expand-all') | transloco"
            [attr.aria-label]="(isTreeExpanded ? 'collapse-all' : 'expand-all') | transloco"
          >
            <mat-icon class="mat-icon-rtl-mirror">{{ isTreeExpanded ? 'expand_more' : 'chevron_right' }}</mat-icon>
          </button>
        }

        @if (!column?.hideTitle && column.name !== 'actions') {
          <!-- Nome da coluna -->
          <div class="pr-0">
            <!-- Verificar Tradução -->
            @if (column.translate === undefined || column.translate === true) {
              {{ column?.headerTitleCase === false ? t(column.alias || column.name) : (t(column.alias || column.name) | titlecase) }}
            } @else {
              {{ column?.headerTitleCase === false ? column.alias || column.name : (column.alias || column.name | titlecase) }}
            }
          </div>
        }

        <!-- Título da coluna de AÇÕES: engrenagem em vez de vazio (F14) — mesma razão da `hmax-table`. -->
        @if (column.name === 'actions' && !column?.icon && !column?.hideTitle) {
          <!-- `w-full` + `justify-center`: a engrenagem no MESMO eixo do `⋮` centralizado da célula. -->
          <div class="flex w-full justify-center print:hidden">
            <mat-icon class="icon-size-5 text-secondary" [svgIcon]="column.actionsIcon || 'heroicons_outline:cog-6-tooth'"></mat-icon>
          </div>
        }

        @if (column?.icon) {
          <mat-icon
            class="icon-size-4 print:hidden"
            [ngClass]="column.icon?.color"
            [svgIcon]="column.icon?.name || ''"
            [matTooltip]="column | tooltipText"
            [matTooltipPosition]="column.icon?.tooltip?.position || 'above'"
          >
          </mat-icon>
        }
      </mat-header-cell>

      <!-- Dado da célula -->
      <mat-cell
        *matCellDef="let row; let cellIndex = dataIndex; let index = index"
        [hidden]="column.hidden || (column.name === 'id' && column.hidden === undefined)"
        [style.minWidth.px]="column.minWidth"
        [style.maxWidth.px]="column.name === 'actions' ? 56 : column.maxWidth"
        class="overflow-visible {{
          'px-1 dark:print:bg-white dark:print:text-black dark:print:border-b ' + (column.cellClass ? column.cellClass : '')
        }}"
        [class.border-b-0]="columns | hideBorderBottom: hideBottomBorder"
        [class.flex-col]="row | checkUnderline: column"
        [class.items-start]="row | checkUnderline: column"
        [ngClass]="[column | columnAlignment, column?.hiddenSize || '']"
        [class.z-10]="column.sticky"
        [class.bg-slate-200]="index % 2 !== 0 && isZebraEnabled"
        [class.dark:bg-slate-600]="index % 2 !== 0 && isZebraEnabled"
        [class.bg-card]="column.sticky && ((index % 2 === 0 && isZebraEnabled) || !isZebraEnabled)"
        (click)="doCellClick(column, cellIndex, row)"
      >
        <!-- Só com algum nó expansível (`hasExpandableRows`): numa lista plana o botão invisível guardava
             ~48px à esquerda e descentralizava o conteúdo da coluna do título. Com filho em algum lugar, ele
             volta em toda linha, invisível na folha, para as linhas continuarem alinhadas. -->
        @if (column.name === columns[0]?.name && hasExpandableRows) {
          <button
            mat-icon-button
            [style.visibility]="!row.expandable ? 'hidden' : ''"
            [style.marginLeft.px]="row.level * 32"
            (click)="treeControl.toggle(row)"
          >
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(row) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
        }

        <div class="flex items-center" [ngClass]="row[column?.class || '']" [ngStyle]="row[column?.style || '']">
          @switch (column?.type) {
            <!-- Posição com as setas ao lado, sob o mesmo título (F15/D200), pela mesma razão da `hmax-table`:
                 o valor pela regra da NUMBER, as setas pelo `actionClick`, e a seta da ponta some guardando o
                 lugar. -->
            @case ('REORDER') {
              <div class="flex items-center gap-1">
                @if (reorderRows) {
                  <!-- O ícone padrão de arrastar, só enquanto as linhas arrastam (F15, Organizar): a linha inteira
                       continua arrastável, e o ícone é o sinal disso. -->
                  <mat-icon
                    class="icon-size-5 text-hint cursor-grab print:hidden"
                    svgIcon="mat_outline:drag_indicator"
                    data-testid="reorder-drag-icon"
                  ></mat-icon>
                }
                <span class="min-w-6 text-right tabular-nums">{{ row | columnFormattedValue: column : currency }}</span>
                <div class="flex items-center print:hidden">
                  <hmax-button-icon-small
                    icon="heroicons_outline:arrow-up"
                    [tooltipText]="t('move-up') | capitalize"
                    [class.invisible]="!!row[column.reorderFirstField ?? '']"
                    (click)="$event.stopPropagation(); doActionClick('moveUp', cellIndex, row)"
                  ></hmax-button-icon-small>
                  <hmax-button-icon-small
                    icon="heroicons_outline:arrow-down"
                    [tooltipText]="t('move-down') | capitalize"
                    [class.invisible]="!!row[column.reorderLastField ?? '']"
                    (click)="$event.stopPropagation(); doActionClick('moveDown', cellIndex, row)"
                  ></hmax-button-icon-small>
                </div>
              </div>
            }

            <!-- ÍCONE por LINHA (F14): o `column.icon` do cabeçalho é outro recurso — aquele é fixo da
                 coluna, este vem do dado. Célula vazia não desenha placeholder. -->
            @case ('ICON') {
              @if (row[column.name]) {
                <mat-icon class="icon-size-5" [svgIcon]="(column.iconPrefix || 'mat_outline') + ':' + row[column.name]"></mat-icon>
              }
            }

            <!-- Miniatura ILUSTRATIVA (F14): diz "este item tem foto", não é a foto em tamanho útil.
                 `loading="lazy"` porque a listagem é longa e a imagem não é o assunto da linha.
                 Célula vazia não desenha placeholder — moldura cinza em item sem foto é ruído. -->
            @case ('IMAGE') {
              @if (row[column.name]) {
                <img [src]="row[column.name]" alt="" loading="lazy" class="h-8 w-8 shrink-0 rounded object-cover" />
              }
            }

            <!-- SELECT type -->
            @case ('SELECT') {
              <div class="w-full" style="min-height: 40px">
                <mat-select
                  [value]="row[column.name]"
                  (selectionChange)="onSelectChange($event, column, row)"
                  [disabled]="column.disabled"
                  class="w-full"
                  style="min-height: 40px; min-width: 280px; text-align: center; white-space: nowrap"
                  panelClass="select-wide-panel"
                  [disableOptionCentering]="true"
                  placeholder="{{ t('select-item') }}"
                >
                  <!-- Opção vazia para remover seleção -->
                  <mat-option [value]="null"></mat-option>

                  @for (option of selectOptions[column.optionsKey || column.name]; track option.value || option) {
                    <mat-option [value]="option.value || option">
                      <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block">
                        {{ option.label || option.name || option | capitalize }}
                      </span>
                    </mat-option>
                  }
                </mat-select>
              </div>
            }

            <!-- Link -->
            @case ('LINK') {
              @if (column?.linkField && row[column.linkField]; as linkValue) {
                @if (!column?.isInternalLink) {
                  <a [href]="row[linkValue]" target="_blank" rel="noopener noreferrer" class="text-blue-600 hover:text-blue-400 underline">
                    {{ (column?.linkAliasTranslate ? t(row[column?.linkAlias || '']) : row[column?.linkAlias || '']) | titlecase }}
                  </a>
                }

                @if (column?.isInternalLink) {
                  <a [routerLink]="[row[linkValue]]" class="text-blue-600 hover:text-blue-400 underline cursor-pointer">
                    {{ (column?.linkAliasTranslate ? t(row[column?.linkAlias || '']) : row[column?.linkAlias || '']) | titlecase }}
                  </a>
                }
              }
            }

            <!-- Padrão -->
            @default {
              @if (column?.type && typesColumnFormatted.includes(column.type)) {
                {{ row | columnFormattedValue: column : currency }}
              } @else {
                {{ (column.translate ? t(row | columnValue: column | lowercase) : (row | columnValue: column)) | formatColumnText: column }}
              }
            }
          }
        </div>

        <!-- Actions -->
        @if (column?.actions?.length) {
          <!-- Centralizado na coluna, como na `hmax-table`: o `mat-icon-button` tem alvo de 40px e a célula
               só 48px úteis, então qualquer padding lateral empurra o hover para fora e ele sai cortado. -->
          <div class="flex w-full justify-center print:hidden">
            <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
              <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:more_vert'"> </mat-icon>
            </button>

            <mat-menu #actionsMenu="matMenu">
              @for (action of column.actions; track $index) {
                @if ((!!action.divider || (action.label === 'remove' && (column.actions?.length || 0) > 1)) && !row[action?.hide]) {
                  <mat-divider class="my-2"> </mat-divider>
                }

                @if (!row[action?.hide] && !action.divider) {
                  <button mat-menu-item (click)="doActionClick(action.method, $index, row)">
                    <mat-icon class="icon-size-5" [ngClass]="action?.class" [svgIcon]="action?.icon || ''"></mat-icon>
                    <span [ngClass]="action?.class">{{ (action?.translate !== false ? t(action.label) : action.label) | titlecase }}</span>
                  </button>
                }
              }
            </mat-menu>
          </div>
        }
      </mat-cell>
    </ng-container>
  }
  <mat-header-row *matHeaderRowDef="columns | columnNames"></mat-header-row>
  <!-- F15 — `cdkDrag` só liga com `reorderRows`: a linha inteira arrasta, travada no eixo vertical, e só cai
       onde o `sortPredicate` deixa (entre irmãos). No toque, só depois de segurar um instante, para o dedo
       ainda conseguir rolar a página. -->
  <mat-row
    *matRowDef="let row; let i = index; columns: columns | columnNames"
    [ngClass]="{
      'bg-slate-200 dark:bg-slate-600': i % 2 !== 0 && isZebraEnabled,
      'bg-card': (i % 2 === 0 && isZebraEnabled) || !isZebraEnabled,
    }"
    [class.cursor-grab]="reorderRows"
    cdkDrag
    [cdkDragData]="row"
    [cdkDragDisabled]="!reorderRows"
    cdkDragLockAxis="y"
    cdkDragPreviewContainer="parent"
    [cdkDragStartDelay]="{ touch: 200, mouse: 0 }"
    (cdkDragStarted)="onDragStarted()"
    (click)="doRowClick(i, row)"
  >
  </mat-row>
</table>
